// quiz-barf-recipe-results.js
(function initQuizBarfRecipeResults() {
  window.CatQuiz = window.CatQuiz || {};

  const logic = () => window.CatQuizRecipeLogic || CatQuiz.recipeLogic;

  const state = {
    bound: false
  };

  function getRoot() {
    return logic()?.getRoot?.() || document.getElementById("cat-nutrition-quiz");
  }

  function getForm(root = getRoot()) {
    return logic()?.getForm?.(root) || root?.querySelector?.("#cat-quiz-form") || null;
  }

  function normalizeFlow(value) {
    return logic()?.normalizeFlow?.(value) || String(value || "").trim().toLowerCase();
  }

  function isEligible(answers = {}, form = getForm()) {
    const flow = normalizeFlow(answers?.foodChoice || logic()?.getCurrentFlow?.(form));
    return !!logic()?.isBarfResultEligible?.(flow);
  }

  function renderCard(recipe, selected) {
    const details = logic()?.recipeDetails?.(recipe) || { title: recipe.fallbackTitle, priceCents: null };
    const title = details?.title || recipe.fallbackTitle;
    const price = logic()?.formatPrice?.(details?.priceCents) || "–";
    const addLabel = selected ? "Hinzugefügt" : "Rezept hinzufügen";
    const addClass = selected ? " is-selected" : "";

    return `
      <article class="barf-recipe-results-card" data-barf-recipe-result-card data-variant-id="${recipe.variantId}">
        <div class="barf-recipe-results-card__body">
          <h5 class="barf-recipe-results-card__title">${logic()?.escapeHtml?.(title) || title}</h5>
          <div class="barf-recipe-results-card__price">${logic()?.escapeHtml?.(price) || price}</div>
          <button type="button" class="barf-recipe-results-card__info" data-barf-recipe-result-info="${recipe.variantId}">
            Mehr Infos
          </button>
        </div>

        <div class="barf-recipe-results-card__footer">
          <button
            type="button"
            class="barf-recipe-results-card__add${addClass}"
            data-barf-recipe-result-toggle="${recipe.variantId}"
            aria-pressed="${selected ? "true" : "false"}"
          >
            ${logic()?.escapeHtml?.(addLabel) || addLabel}
          </button>
        </div>
      </article>
    `;
  }

  function renderGroup(title, recipes, selectedSet) {
    if (!Array.isArray(recipes) || !recipes.length) return "";

    return `
      <section class="barf-recipe-results-group" data-barf-recipe-group="${title.toLowerCase()}">
        <h3 class="barf-recipe-results-group__title">${title}</h3>
        <div class="barf-recipe-results-group__surface">
          <div class="barf-recipe-results-group__grid">
            ${recipes.map((recipe) => renderCard(recipe, selectedSet.has(recipe.variantId))).join("")}
          </div>
        </div>
      </section>
    `;
  }

  function renderInner(context = {}) {
    const form = context.form || getForm();
    const answers = context.answers || {};
    const groups = logic()?.getBarfGroupedRecipes?.(answers) || { fish: [], meat: [] };
    const allowedRecipes = [...groups.fish, ...groups.meat];
    const selectedIds = logic()?.syncSelectedIdsToAllowedRecipes?.(allowedRecipes, form) || [];
    const selectedSet = new Set(selectedIds);

    if (!allowedRecipes.length) {
      return `
        <div class="barf-recipe-results__empty">
          Aktuell gibt es für diese Allergiekombination noch keine passenden BARF-Rezepte.
        </div>
      `;
    }

    return `
      <div class="barf-recipe-results__inner">
        ${renderGroup("Fisch", groups.fish, selectedSet)}
        ${renderGroup("Fleisch", groups.meat, selectedSet)}
      </div>
    `;
  }

  function renderResultSection(context = {}) {
    if (!isEligible(context.answers, context.form)) return "";
    return `
      <section class="barf-recipe-results" data-barf-recipe-results-root>
        ${renderInner(context)}
      </section>
    `;
  }

  function refreshSection(context = {}) {
    const root = context.quizRoot || getRoot();
    const form = context.form || getForm(root);
    const answers = context.answers || {};
    const host = root?.querySelector?.("[data-barf-recipe-results-root]");
    if (!host) return;
    host.innerHTML = renderInner({ answers, form, quizRoot: root });
  }

  function ensureModal() {
    let overlay = document.querySelector(".barf-recipe-results-modal-overlay");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "barf-recipe-results-modal-overlay";
      overlay.hidden = true;
      overlay.innerHTML = `
        <div class="barf-recipe-results-modal" role="dialog" aria-modal="true" aria-labelledby="barf-recipe-results-modal-title">
          <button
            type="button"
            class="barf-recipe-results-modal__close"
            data-barf-recipe-modal-close
            aria-label="Schließen"
          >×</button>
          <div class="barf-recipe-results-modal__inner">
            <h4 class="barf-recipe-results-modal__title" id="barf-recipe-results-modal-title"></h4>
            <div class="barf-recipe-results-modal__section">
              <div class="barf-recipe-results-modal__label">Inhaltsstoffe</div>
              <div class="barf-recipe-results-modal__content"></div>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(overlay);
    }

    const closeBtn = overlay.querySelector("[data-barf-recipe-modal-close]");
    const modalEl = overlay.querySelector(".barf-recipe-results-modal");

    if (closeBtn) {
      closeBtn.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      };
    }

    overlay.onclick = (event) => {
      if (event.target === overlay) {
        closeModal();
      }
    };

    if (modalEl) {
      modalEl.onclick = (event) => {
        event.stopPropagation();
      };
    }

    if (!overlay.__barfRecipeEscBound) {
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !overlay.hidden) {
          closeModal();
        }
      });
      overlay.__barfRecipeEscBound = true;
    }

    return overlay;
  }

  function closeModal() {
    const overlay = document.querySelector(".barf-recipe-results-modal-overlay");
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.classList.remove("modal-open");
    document.body.classList.remove("modal-open");
  }

  function openModal(variantId) {
    const recipe = logic()?.getBarfCatalog?.().find((item) => item.variantId === Number(variantId));
    if (!recipe) return;

    const details = logic()?.recipeDetails?.(recipe) || { title: recipe.fallbackTitle };
    const title = details?.title || recipe.fallbackTitle;
    const contentHtml = Array.isArray(recipe.ingredients) && recipe.ingredients.length
      ? `<ul class="barf-recipe-results-modal__list">${recipe.ingredients.map((item) => `<li>${logic()?.escapeHtml?.(item) || item}</li>`).join("")}</ul>`
      : `<p>Inhaltsstoffe folgen.</p>`;

    const overlay = ensureModal();
    overlay.querySelector(".barf-recipe-results-modal__title").textContent = title;
    overlay.querySelector(".barf-recipe-results-modal__content").innerHTML = contentHtml;
    overlay.hidden = false;
    document.documentElement.classList.add("modal-open");
    document.body.classList.add("modal-open");
  }

  function bindUi() {
    if (state.bound) return;
    const root = getRoot();
    if (!root) return;

    root.addEventListener("click", (event) => {
      const infoBtn = event.target.closest("[data-barf-recipe-result-info]");
      if (infoBtn) {
        event.preventDefault();
        openModal(Number(infoBtn.dataset.barfRecipeResultInfo));
        return;
      }

      const toggleBtn = event.target.closest("[data-barf-recipe-result-toggle]");
      if (toggleBtn) {
        event.preventDefault();
        const form = getForm(root);
        logic()?.toggleSelectedId?.(Number(toggleBtn.dataset.barfRecipeResultToggle), form);
        refreshSection({ quizRoot: root, form, answers: window.CatQuiz?.main?.getAnswers?.() || {} });
      }
    });

    state.bound = true;
  }

  function mountResultSection(context = {}) {
    const root = context.quizRoot || getRoot();
    const form = context.form || getForm(root);
    const answers = context.answers || {};
    if (!root || !form || !isEligible(answers, form)) return;

    logic()?.ensureSelectionField?.(form);
    bindUi();
    refreshSection({ quizRoot: root, form, answers });

    const hydratePromise = logic()?.hydrateCatalog?.();
    if (hydratePromise && typeof hydratePromise.then === "function") {
      hydratePromise
        .then(() => {
          refreshSection({
            quizRoot: root,
            form,
            answers: window.CatQuiz?.main?.getAnswers?.() || answers
          });
        })
        .catch(() => {});
    }
  }

  function buildCartItems(context = {}) {
    const answers = context.answers || {};
    const form = context.form || getForm(context.quizRoot || getRoot());
    if (!isEligible(answers, form)) return [];

    const allowed = logic()?.getBarfFilteredRecipes?.(answers) || [];
    const allowedIds = new Set(allowed.map((item) => Number(item.variantId)));
    const selectedIds = (logic()?.readSelectedIds?.(form) || []).filter((id) => allowedIds.has(Number(id)));

    return selectedIds.map((variantId) => ({
      id: variantId,
      quantity: 1,
      properties: {
        "Plan-Typ": "Rezept",
        "Rezept-Flow": "BARF-Rezept"
      }
    }));
  }

  const api = {
    renderResultSection,
    mountResultSection,
    buildCartItems,
    openModal,
    closeModal
  };

  window.CatQuizBarfRecipeResults = api;
  CatQuiz.barfRecipeResults = api;
})();
